import React, { RefObject, useCallback, VFC } from 'react';

import { Text, Icon } from 'mintel-react-ui';
import { utils, writeFile } from 'xlsx';

import useTranslate from '/utils/translations';

import styles from './TableDownload.scss';

type TableDownloadProps = {
  tableRef: RefObject<HTMLTableElement>;
  filename: string;
  darkBg?: boolean;
};

const TableDownload: VFC<TableDownloadProps> = ({
  tableRef,
  filename,
  darkBg = false,
}) => {
  const t = useTranslate();

  const downloadHandler = useCallback(() => {
    if (tableRef?.current) {
      const workbook = utils.table_to_book(tableRef.current);
      writeFile(workbook, filename);
    }
  }, [tableRef, filename]);

  return (
    <div className={styles.container}>
      <Text.Body2 darkBg={darkBg}>
        <a
          className={styles.button}
          onClick={downloadHandler}
          role="button"
          tabIndex={0}
        >
          <Icon
            color={styles[darkBg ? 'darkbg-icon-color' : 'icon-color']}
            name="download_outline"
            size={20}
          />
          {t('Download table (.csv)')}
        </a>
      </Text.Body2>
    </div>
  );
};

export default TableDownload;
